export class CameraSettingsData {
    constructor() {}

    static MiniSettings: any = {
        UserID: null,
        Ssid: 'HAIDER',
        Password: 'Test@1234',
        Prerecord: true,
        LiveViewFps: 0,
        LiveViewBitrate: 1,
        RecordingSize: 10,
        RecordingTime: 4,
        RecordingQuality: 0,
        PowerOff: 0,
        DateImprint: true,
        AudioRecord: false,
        AutoRecording: '0',
        SystemReset: false,
        BurnText: '',
        FunctionType: 1,
        IRMode: 0,
        ThresholdLightOn: 80,
        ThresholdLighOff: 300,
        delay: 5,
        samplingTimes: 5,
        calculateMode: 0,
        WifiMode: 0,
        PhotoSize: 5,
        IRCUTSensitivity: 5,
        RecordingNotification: 0,
        LEDLight: 1,
        StealthMode: 1,
        AutoStartWifi: 0,
        EnableWatermark: 1,
        BeepSound: 0,
        PreRecordMute: 0,
        BurstMode: 0,
        FileProtection: 0,
        CurrentCameraProvider: 4,
        WifiConnectionMode: 1,
        APSsid: 'Matrix_4G',
        APPassword: '12344567890',
        P2PDeviceName: 'BWV',
        AppCreateHotspot: 0,
        CameraProvider: 4,
        Matrix2ID: 160127,
        Matrix2PlusID: 70076,
        Matrix4GID: 27,
        RoleID: null,
        CompanyID: 1,
        SourceType: 3,
        StreamingResolution: 3,
        StreamingBitrate: 6,
        StreamingControl: 3,
        VideoMute: 2,
        PreRecordingTime: 2,
        PostRecord: 0,
        RefreshRate: 0,
        PhotoQuality: 1,
        IntervalShooting: 0,
        SelfieTime: 0,
        Volume: 10,
        Brightness: -1,
        OutputTV: 0,
        FileTagging: 0,
        TimeZone: 24,
        DateFormat: 0,
        Language: 0,
        ShockReminding: 0,
        Playback: 0,
        ScreenSaver: 2,
        WebServer: 2,
        ChargeState: 2,
        LocationService: true,
        KeyTone: '0',
        Standby: false,
        AutoSyncTime: false,
        CarMode: false,
        AutoBrightness: false,
        LoopRecording: '0',
        AutoDetection: false,
        ClockBeep: false,
        DataEncryption: 0,
        DecryptionPlay: 0,
        DESKey: '',
        BuzzerRings: 5,
        BuzzerTime: 100,
        LedColor: 0,
        LedState: 0,
        LedInterval: 0,
        HeartbeatTimeOut: 0,
        Barcode: null,
        NetworkName: 'Matrix_4G',
        ServerIP: '192.168.0.1',
        WifiMacAddress: null,
        APCameraIP: '',
        APLinkNumber: 5,
        APChannelParameter: 11,
        APChannelSelection: 0,
        P2PPinCode: '98765432',
        BluetoothAddress: '',
        BluetoothMode: 1,
        G4Mode: 1,
        MotionDetection: 'Off',
        Network_Protocol: 0,
        Network_ServerArea: 3,
        Network_ServerURL: '',
        Network_ServerPort: 6608,
        Network_Account: '',
        Network_Password: '',
        WIFI_ConnectTimeout: 0,
        WIFI_Gateway: '192.168.42.1',
        STA_AutoGetIP: 0,
        Bluetooth_PairName: '',
        Bluetooth_PairMac: '',
        Bluetooth_HeartRateFrom: 45,
        Bluetooth_HeartRateTo: 130,
        FourG_SIMPIN: '',
        FourG_APN: '',
        FourG_APN_Username: '',
        FourG_APN_Password: '',
        StreamingFrameRate: 2,
        EncodingFormat: 0,
        VideoEIS: 0,
        DoubleClickRecord: 0,
        LowSpaceWarning: 1,
        LowBatteryWarning: 1,
        CustomizedCode: '################################',
        UpdateCertificate: 0,
        GPSFrequency: 30,
        MediaServerAddress: 'media-server-trial.mview.com.au:1935',
        MediaServerUserName: null,
        MediaServerPassword: null,
        APIServerAddress: null,
        DashCamMode: '1',
        STAName: '',
        HotspotName: '',
        PhotoInterval: 0,
        PhotoTimer: '0',
        CameraNotification: 0,
        Vibration: '1',
        GPS: '0',
        MuteRecording: false,
        RecordingSegment: '2',
        StreamingAudioControl: 1,
        StreamingVideoControl: 1,
        '4G': '0',
        KeyToneVolume: 5,
        DisplayBrightness: '-1',
        ScreenTimeout: '10'
    };
}
